module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Weather/Storm-a73bd0bc8c7cabef023215dc6239d55ffd80f525b9eb5f19585e4dd9df80e03a.svg";